
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    title: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    error: { type: Boolean, default: false },
    subtitleLink: { type: String, default: '' },
  },
});
